import ActionsForm from '@/shared/mixins/actionsForm'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import searchocurrence from './components/searchocurrence/searchocurrence.vue'
import tableocurrence from './components/tableocurrence/tableocurrence.vue'
import addocurrence from './components/addocurrence/addocurrence.vue'
import groupbuttonocurrence from '@/views/private/realestate/ocurrence/components/groupbuttonocurrence/groupbuttonocurrence.vue'
import KabanOcorrence from './components/KabanOcorrence/KabanOcorrence.vue'
import sorting from '@/views/private/realestate/ocurrence/components/sorting/sorting.vue'
import data from './components/technicalvisit/agendatechnical/data'
import Roles from '@/shared/utils/roles.js'
import PermissionMixin from '@/store/module/permission/mixin'
import AccountMixin from '@/store/module/account/mixin'
import CompanyMixin from '@/store/module/company/mixin'

export default {
  mixins: [ActionsForm, ExpenseMixin, AccountMixin, CompanyMixin, PermissionMixin],
  name: 'Ocurrences',
  data () {
    return {
      kanbanOn: false,
      telaInicial: true,
      dataDetails: {},
      firstcol: 3,
      flchangeMinizado: false,
      dataSearchDetails: {},
      formnewoccourence: data,
      roles: Roles
    }
  },

  components: {
    AutocompleteZ, sorting, searchocurrence, tableocurrence, addocurrence, KabanOcorrence, groupbuttonocurrence },
  methods: {
    changeKanban (kanban) {
      this.kanbanOn = kanban
    },
    search (obj) {
      this.dataSearchDetails = obj
      if (!this.kanbanOn) {
        this.$refs.tableocurrence.dataSearch = obj
        this.$refs.tableocurrence.onload()
      } else {
        this.$refs.KabanOcorrence.dataSearch = obj
        this.$refs.KabanOcorrence.GetAllOcourenceKanban()
      }
    },
    edit (data) {
      this.dataDetails = data
      this.telaInicial = false
    },
    reload () {
      this.$refs['tableocurrence'].onload()
    },
    changeMinizado () {
      this.flchangeMinizado = !this.flchangeMinizado
      if (this.flchangeMinizado) {
        let firstcol = document.getElementById('first-col')
        firstcol.classList.remove('col-md-3')
        firstcol.classList.add('col-md-1')
        let secondcol = document.getElementById('second-col')
        secondcol.classList.remove('col-md-9')
        secondcol.classList.add('col-md-11')
      } else {
        let firstcol = document.getElementById('first-col')
        firstcol.classList.remove('col-md-1')
        firstcol.classList.add('col-md-3')
        let secondcol = document.getElementById('second-col')
        secondcol.classList.remove('col-md-11')
        secondcol.classList.add('col-md-9')
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/ocurrence/ocurrence.js